var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowthCapital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22456 10.2842L1.03007 6.06987C0.620095 5.65796 0.807448 4.95595 1.3673 4.80757L7.09809 3.26403C7.69762 3.10236 8.33462 3.2751 8.77324 3.7158L12.9677 7.93009C13.3777 8.342 13.1904 9.04401 12.6305 9.19239L6.89972 10.7359C6.30239 10.8954 5.66319 10.7249 5.22456 10.2842Z",
    fill: "#41D3BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03569 7.07972L1.84119 2.86543C1.43122 2.45352 1.61857 1.75151 2.17843 1.60313L7.90922 0.0595898C8.50875 -0.102073 9.14575 0.0706626 9.58437 0.511359L13.7789 4.72565C14.1888 5.13756 14.0015 5.83957 13.4416 5.98795L7.71084 7.53149C7.11132 7.69094 6.47432 7.52042 6.03569 7.07972Z",
    fill: "#098AED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41563 13.4887L0.221138 9.27436C-0.188834 8.86246 -0.00148127 8.16044 0.558373 8.01207L6.28916 6.46853C6.88869 6.30686 7.52569 6.4796 7.96432 6.92029L12.1588 11.1346C12.5688 11.5465 12.3814 12.2485 11.8216 12.3969L6.09079 13.9404C5.49346 14.1021 4.85426 13.9294 4.41563 13.4887Z",
    fill: "#098AED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96432 6.92028C7.52569 6.47958 6.88649 6.30906 6.28916 6.46851L2.45615 7.50049L5.22676 10.2842C5.66539 10.7249 6.30459 10.8954 6.90192 10.736L10.7349 9.70397L7.96432 6.92028Z",
    fill: "url(#ss-growth-capital--lg-1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77325 3.71581C8.33462 3.27512 7.69542 3.10459 7.09809 3.26404L3.26508 4.29602L6.03569 7.07972C6.47432 7.52041 7.11352 7.69093 7.71084 7.53149L11.5439 6.4995L8.77325 3.71581Z",
    fill: "url(#ss-growth-capital--lg-2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-growth-capital--lg-1",
    x1: 0.794072,
    y1: 8.60223,
    x2: 14.4722,
    y2: 8.60223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41D3BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098AED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-growth-capital--lg-2",
    x1: 2.84602,
    y1: 5.39776,
    x2: 11.7127,
    y2: 5.39776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B17AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098AED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthCapital);
export default __webpack_public_path__ + "static/media/growth-capital.3cc66de9.svg";
export { ForwardRef as ReactComponent };